var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 col-lg-3 mb-3" },
    [
      _vm.valueTypeIsNumber
        ? _c(
            "material-input",
            {
              staticClass: "form-group-material-no-label",
              attrs: {
                value: _vm.values[0].value,
                "custom-expression":
                  "currentSegment.conditions.$each[" +
                  _vm.index +
                  "].values.$each[0].value",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: {
                      mask: "9{1,}.{0,1}999",
                      greedy: false,
                      showMaskOnFocus: false,
                      showMaskOnHover: false,
                      placeholder: "",
                    },
                    expression:
                      "{\n        mask: '9{1,}.{0,1}999',\n        greedy: false,\n        showMaskOnFocus: false,\n        showMaskOnHover: false,\n        placeholder: ''\n      }",
                  },
                ],
                attrs: {
                  id: "condition-value-" + _vm.index,
                  placeholder: _vm.conditionName,
                },
                domProps: { value: _vm.values[0].value },
                on: {
                  change: function ($event) {
                    return _vm.handleChange($event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "d-none",
                  attrs: { for: "condition-value-" + _vm.index },
                },
                [_vm._v(_vm._s(_vm.$t("global.words.conditionValue")))]
              ),
            ]
          )
        : _vm.valueTypeIsDate
        ? _c(
            "material-input",
            {
              staticClass: "form-group-material-no-label",
              attrs: {
                value: _vm.values[0].value,
                "custom-expression":
                  "currentSegment.conditions.$each[" +
                  _vm.index +
                  "].values.$each[1].value",
              },
            },
            [
              _c("datepicker-input", {
                attrs: {
                  value: _vm.values[0].value,
                  placeholder: _vm.conditionName,
                  "show-calendar": false,
                },
                on: { change: _vm.handleChange },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }